'use strict';

angular.module('TurneroApp').component('coCertificado',{
  controller: [
    '$scope',
    '$sce',
    'turnosService',
    '$stateParams',
    function ($scope, $sce, turnosService, $stateParams) {
      var ctrl = this;
      
      ctrl.turno = {
        Id_Turno: $stateParams.Id_Turno,
      };

      ctrl.certificado = "Cargando..."

      $scope.trustedHtml = function (plainText) {
        return $sce.trustAsHtml(plainText);
      }

      ctrl.getCertificado = function (Id_Turno) {
        ctrl.promise = turnosService.getCertificado({'id': Id_Turno}).$promise.then(function (response) {
          if(response.Data.length > 0){
            ctrl.certificado = response.Data;
          } else {
            ctrl.certificado = "Error al obtener certificado para el turno " + ctrl.turno.Id_Turno;
          }
        }).catch(function (error) {
          ctrl.certificado = "Error al obtener certificado para el turno " + ctrl.turno.Id_Turno;
          console.log("Error ", error)
        });
      }
      ctrl.getCertificado(ctrl.turno.Id_Turno)
    }
  ],
  template: require('./certificado.html')
});



// WEBPACK FOOTER //
// ./app/components/asistencia/certificadoComponent.js